import { useEffect, useState } from "react";
import { Loader2, Save } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { DURATION, TX_TYPE, egp, fmtDate, inputCls, cardCls, btnPrimary } from "@/lib/labels";

export const AdminPricing = () => {
  const [p, setP] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/admin/pricing").then((r) => setP(r.data)).catch((e) => toast.error(errMsg(e))); }, []);
  const save = async (e) => {
    e.preventDefault();
    setBusy(true);
    try { setP((await api.put("/admin/pricing", { short: Number(p.short), long: Number(p.long) })).data); toast.success("الأسعار اتحفظت وهتتطبق على الأوردرات الجديدة بس"); }
    catch (err) { toast.error(errMsg(err)); }
    finally { setBusy(false); }
  };
  if (!p) return <p className="text-purple-300/70">بنحمّل...</p>;
  return (
    <form onSubmit={save} className={`${cardCls} max-w-lg space-y-4 p-6`} data-testid="admin-pricing-form">
      <h2 className="font-display text-3xl text-white">أسعار الإعلانات</h2>
      <p className="text-sm text-purple-300/70">السعر الجديد بيتطبق على الأوردرات الجديدة بس، والأوردرات القديمة بتفضل بسعرها. الأسلوب والفورمات نفس السعر.</p>
      {["short", "long"].map((k) => (
        <label key={k} className="block">
          <span className="mb-1 block text-sm font-bold text-white">{DURATION[k]} (ج.م)</span>
          <input type="number" min="1" dir="ltr" className={`${inputCls} text-right`} value={p[k]} onChange={(e) => setP((x) => ({ ...x, [k]: e.target.value }))} required data-testid={`admin-price-${k}-input`} />
        </label>
      ))}
      <button type="submit" disabled={busy} className={btnPrimary} data-testid="admin-pricing-save-btn">{busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Save className="h-4 w-4" />} حفظ الأسعار</button>
    </form>
  );
};

export const TxList = ({ items, showBrand, testId = "tx-list" }) =>
  items.length === 0 ? <p className="text-sm text-purple-300/70" data-testid={`${testId}-empty`}>مفيش معاملات</p> : (
    <ul className="space-y-2" data-testid={testId}>
      {items.map((t, i) => (
        <li key={t.id} className="flex items-center justify-between gap-3 rounded-2xl bg-black/30 p-3 text-sm" data-testid={`${testId}-item-${i}`}>
          <span className="min-w-0">
            <span className="font-head block font-bold text-white">{TX_TYPE[t.type] || t.type}{showBrand && t.brand_name ? ` · ${t.brand_name}` : ""}</span>
            <span className="block break-words text-xs text-purple-300/70">{t.note}{t.admin_email ? ` · بواسطة ${t.admin_email}` : ""}</span>
            <span className="block text-[11px] text-purple-300/50">{fmtDate(t.created_at)}{t.balance_after != null ? ` · الرصيد بعدها ${egp(t.balance_after)}` : ""}</span>
          </span>
          <span className={`font-head shrink-0 font-bold ${t.amount < 0 ? "text-red-300" : "text-green-300"}`} dir="ltr">{t.amount > 0 ? "+" : ""}{Number(t.amount).toLocaleString("ar-EG")}</span>
        </li>
      ))}
    </ul>
  );

export const AdminTransactions = () => {
  const [items, setItems] = useState(null);
  useEffect(() => { api.get("/admin/transactions").then((r) => setItems(r.data)).catch(() => setItems([])); }, []);
  if (items === null) return <p className="text-purple-300/70">بنحمّل...</p>;
  return (
    <section data-testid="admin-transactions">
      <h2 className="font-display mb-5 text-3xl text-white">كل معاملات المحافظ <span className="text-[var(--km-pink)]">({items.length})</span></h2>
      <TxList items={items} showBrand testId="admin-tx" />
    </section>
  );
};
